import { useQuery } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { useOrgId } from 'hooks/index.js';
import { vodUrl } from '../../../client-config.js';
import { ITEMS_PER_PAGE } from 'pages/Videos/constants.js';

const useVodActionsQuery = (queryParams = {}, options = {}) => {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const { filterBy, page, pageSize = ITEMS_PER_PAGE, sortBy, sortOrder, search, searchFields } = queryParams;

  return useQuery({
    queryKey: ['vodActions', orgId, { filterBy, search, page, pageSize, sortBy, sortOrder, searchFields }],
    queryFn: async () => {
      const idToken = await firebase.getIdToken();
      const fetchUrl = new URL(`${vodUrl}/v1/orgs/${orgId}/actions`);

      const offset = (page - 1) * pageSize;
      const urlParams = new URLSearchParams({
        ...(filterBy && { filterBy }),
        ...(search && { search }),
        ...(search && searchFields && { searchFields }),
        ...(offset && { offset }),
        ...(pageSize && { pageSize }),
        ...(sortBy && { sortBy }),
        ...(sortOrder && { sortOrder: sortOrder.toUpperCase() }),
      });
      fetchUrl.search = urlParams.toString();

      const response = await fetch(fetchUrl.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
      });
      const { ok, status } = response;
      if (ok) {
        return response.json();
      } else {
        throw new Error(`Failed to fetch actions. Status: ${status}`);
      }
    },
    keepPreviousData: true,
    ...options,
  });
};

export default useVodActionsQuery;
